import React from 'react'

export default function NotFound() {
    return (
        <div className="flex h-screen">
            <h1 className="text-4xl m-auto">Page Not Found</h1>
        </div>
    )
}
